import { EditorState } from "prosemirror-state";
import { Node } from "prosemirror-model";

export function getTopLevelNodes(state: EditorState) {
	const ret = Array<{ node: Node; pos: number }>();
	// we only allow text align and indent for paragraphs right below doc,
	// not paragraphs inside list items
	state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos) => {
		ret.push({ node, pos });
		return false;
	});
	return ret;
}

export function getTopLevelParagraphsAndHeadings(state: EditorState) {
	const ret = Array<{ node: Node; pos: number }>();
	// we only allow text align and indent for p's and h's right below doc,
	//but not when inside list items
	state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos) => {
		if (
			node.type === state.schema.nodes.paragraph ||
			node.type === state.schema.nodes.heading
		) {
			ret.push({ node, pos });
		}
		return false;
	});
	return ret;
}
